import {
  Building2,
  ChartNoAxesColumn,
  Clipboard,
  List,
  LogOut,
  PhoneCall,
  Settings,
  UserPlus,
  Users,
  GraduationCap,
  Compass,
} from "lucide-react";
import AiIcon from "@/assets/svg/Ai-Icon";
import { USER_ROLES } from "@/shared/utils/constants";

export function isNavItemActive(pathname, navLink) {
  if (!navLink?.url || navLink.action) return false;
  return (
    pathname === navLink.url ||
    pathname.startsWith(`${navLink.url}/`)
  );
}

export function getNavItemsForRole({ user, isAdminMode, isOrgAdmin }) {
  const isSuperAdmin =
    user?.role === USER_ROLES.SUPER_ADMIN ||
    user?.role === USER_ROLES.SUPER_ADMIN_ALT;

  if (isSuperAdmin) return superAdminNavigations;
  if (isOrgAdmin && isAdminMode) return orgAdminNavigations;
  return navigations;
}

export function getMobileBottomNavItems(params) {
  return getNavItemsForRole(params).filter(
    (item) => item.showInMobileBottomNav && !item.disabled,
  );
}

export function getMobileMenuItems(params) {
  return getNavItemsForRole(params).filter((item) => item.showInMobileMenu);
}

export function hasMobileCenterNavItem(items) {
  return items.some((item) => item.mobileCenter);
}

// Super Admin Navigations
export const superAdminNavigations = [
  {
    id: 1,
    title: "Dashboard",
    url: "/sa/dashboard",
    iconType: ChartNoAxesColumn,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 2,
    title: "Organizations",
    url: "/sa/organizations",
    iconType: Building2,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 3,
    title: "Calling Approvals",
    url: "/sa/calling-approvals",
    iconType: PhoneCall,
    bottom: false,
    showInMobileMenu: true,
  },
  {
    id: 7,
    title: "Log out",
    url: "/signup",
    iconType: LogOut,
    bottom: true,
    action: true,
    showInMobileMenu: true,
  },
];

// Org Admin Navigations
export const orgAdminNavigations = [
  {
    id: 1,
    title: "Dashboard",
    url: "/oa/dashboard",
    iconType: ChartNoAxesColumn,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 2,
    title: "Members",
    url: "/oa/members",
    iconType: Users,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 3,
    title: "Pending Requests",
    url: "/oa/pending-members",
    iconType: UserPlus,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 4,
    title: "Sales Coach",
    url: "/oa/sales-coach",
    iconType: GraduationCap,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 7,
    title: "Log out",
    url: "/signup",
    iconType: LogOut,
    bottom: true,
    action: true,
    showInMobileMenu: true,
  },
];

// Member Navigations
export const navigations = [
  {
    id: 1,
    title: "Dashboard",
    url: "/dashboard",
    iconType: ChartNoAxesColumn,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 2,
    title: "Prospecting",
    url: "/prospecting",
    iconType: Compass,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 3,
    title: "Contacts",
    url: "/contacts",
    iconType: UserPlus,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 4,
    title: "Campaigns",
    url: "/campaigns",
    iconType: Clipboard,
    bottom: false,
    showInMobileBottomNav: true,
    mobileCenter: true,
  },
  {
    id: 5,
    title: "Accounts",
    url: "/accounts",
    iconType: List,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 6,
    title: "AI Workspace",
    url: "/ai-workspace",
    iconType: AiIcon,
    bottom: false,
    showInMobileBottomNav: true,
  },
  {
    id: 7,
    title: "Settings",
    url: "/settings",
    iconType: Settings,
    bottom: true,
    showInMobileMenu: true,
  },
  {
    id: 8,
    title: "Log out",
    url: "/signup",
    iconType: LogOut,
    bottom: true,
    action: true,
    showInMobileMenu: true,
  },
];
